import { format, parseISO, parse } from 'date-fns'
import * as textUtil from '@/components/shared/text-util'

export default {
  methods: {
    format24TimeToTime(timeString) {
      if (!timeString) {
        return timeString
      }

      const timeSplit = timeString.split(':')
      const hours = timeSplit[0]
      const mins = timeSplit[1]
      const secs = timeSplit[2]

      // const date = Date.parse(timestampString);
      const date = new Date()
      date.setHours(hours, mins, secs)
      const formattedTime = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

      return `${formattedTime}`
    },
    formatTimestampToDate(timestampString, useShortYear) {
      return textUtil.formatTimestampToDate(timestampString, useShortYear)
    },
    // Example of timestamp String...
    formatTimestampToDateTime(timestampString) {
      if (!timestampString) {
        return timestampString
      }

      const date = new Date(timestampString)
      const dateString = this.formatTimestampToDate(timestampString, true)
      const timeString = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

      return `${dateString} ${timeString}`
    },

    formatTimestampToCommonDate(timestampString) {
      if (!timestampString) {
        return timestampString
      }
      // Convert 2025-03-19
      // to      2025-03-19T00:00:00
      // NOTE: When the UTC offset representation is absent, date-only forms are interpreted as a UTC time and date-time forms are interpreted as a local time.
      if (timestampString.length == 10) {
        timestampString = timestampString + 'T00:00:00'
      }
      // const date = Date.parse(timestampString);
      const date = new Date(timestampString)
      return format(date, 'MM/dd/yyyy')
    },
    isoDateToCommonDate(isoString) {
      return textUtil.isoDateToCommonDate(isoString)
    },
    // Attempts to convert the most common date formats to ISO Date
    userInputDateToIsoDate(userInput) {
      return textUtil.userInputDateToIsoDate(userInput)
    },
    commonDateToIsoDate(commonDateString) {
      if (!commonDateString) return null
      const commonDateFormat = /^\d{1,2}\/\d{1,2}\/\d{4}$/
      if (commonDateFormat.test(commonDateString)) {
        const parsed = parse(commonDateString, 'MM/dd/yyyy', new Date())
        return format(parsed, 'yyyy-MM-dd')
      } else {
        console.log('Did not match format')
        return commonDateString
      }
    },
    // Hopefully I can fix this on the java side
    dumbDateToCommonDate(dumbDate) {
      if (!dumbDate) return null
      // console.log({ dumbDate })
      const parsed = new Date(dumbDate)
      // console.log({ parsed })
      return format(parsed, 'MM/dd/yyyy')
    },
    isoDateToCommonDateTime(isoString) {
      if (!isoString) return null
      return format(parseISO(isoString), 'M/d/yyyy h:mm a')
    },
    // 2024-06-20 => 06/20/2024
    isoToCommon(val) {
      return this.isoDateToCommonDate(val)
    },
  },
}
